export default __webpack_public_path__ + "static/media/CNo.70-2.0dde3faa.jpg";